import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, User, Puser, PatientService, JwtService, CallService } from '../../../shared';
import { SWF } from '../../../shared/models';
import { environment } from '../../../shared/config/app-config';
import { ToastrService } from 'ngx-toastr';
import { last } from 'rxjs/operators';
import { ISubscription } from "rxjs/Subscription";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-threadlist',
  templateUrl: './threadlist.component.html',
  styleUrls: ['./threadlist.component.css', '../messagehosp.component.css']
})
export class ThreadlistComponent implements OnInit {
  index: any = 0;
  messages: any;
  messinfo: [any];
  patswfid: any;
  length: number;
  @Input() threadlist: any;
  @Output() messageEvent = new EventEmitter<string>();
  msginfo;
  CurrentUser: User;
  apiurl: any = environment.api_url;
  public timealert = environment.timelimit;
  public dateform = environment.dateForm;
  currentdate = {};
  public params: any;
  public dateformat = {
    date: {
      pipe: 'dd/MM/yyyy'
    }
  };
  subscription: ISubscription;
  public imageURL: string = environment.cloudeImageURL;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private patientService: PatientService,
    private toast: ToastrService,
    private jwtService: JwtService,
    private Datepipe: DatePipe,
    private callService: CallService

  ) {


  }

  ngOnInit() {
    // this.unread();
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;

      }
    )
    if (this.CurrentUser.item) {
      if (this.CurrentUser.item.hostModel == "CLOUD")
        this.imageURL = environment.cloudeImageURL;
      else
        this.imageURL = environment.vmImageURL;
    } else
      this.imageURL = environment.vmImageURL;

    // this.userService.getmessages(window.localStorage['Puser'])
    if (this.threadlist.messages)
      this.getmessage('')
    this.patientService.getcurrentdate()
      .subscribe(
        data => {
          this.currentdate = data;

        }

      );

  }


  getmessage(length) {
    this.messages = this.threadlist.messages
    for (var i = 0; i < this.messages.length; i++) {
      if (this.messages[i].fracture == 'Y') {
        this.messages[i].fract = 'fracture'
      }
      else {
        this.messages[i].fract = ''
      }
    }
    this.selectmessage(this.messages[0], 0)
  }
  selectmessage(msginfo, ind) {
    this.messages[this.index].open = false
    if (msginfo) {
      this.index = ind
      this.messages[ind].open = true
      this.messages[ind].active = true
      msginfo.unReadMsgCount = 0
      this.messageEvent.emit(msginfo)
    }
  }
  emitmsg(msginfo){
    let mode = 'C'
    this.patientService.getccmessagesinfo(msginfo.patientSwfId, mode)
      .subscribe(data => {
        if(data){
          this.getmsgcount()
        }
      })
  }
  markasunread(msginfo){
    this.patientService.markasunread(msginfo.patientSwfId, this.CurrentUser.item.userAccountId, 'cc')
        .subscribe(
          data => {
            if(data.status == 'success'){
              msginfo.unReadMsgCount =1
              this.getmsgcount();
              // if(msginfo.active){
              //   setTimeout(() => {
              //     msginfo.unReadMsgCount = 0
              //     this.emitmsg(msginfo)
              //   }, 3000);
              // }
            }
               
          })
  }
  getdate(date) {
    date = date.split(' ')
    return date[0]
  }
  getdatetime(date) {
    date = new Date(date)
    if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
      return this.Datepipe.transform(date, 'MM/dd/yyyy hh:mm a');
    } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
      return this.Datepipe.transform(date, 'dd/MM/yyyy hh:mm a');
    }
  }
  gettime(date) {
    date = date.split(' ')
    if (date.length > 3)
      return date[1] + ' ' + date[2] + ' ' + date[3]
    else
      return date[1] + ' ' + date[2]
  }
  getmsgcount() {
    if (window.localStorage['startdate'] && window.localStorage['enddate']) {
      this.patientService.countrange(this.CurrentUser.item.userAccountId, window.localStorage['startdate'], window.localStorage['enddate'])
        .subscribe(
          data => {
            this.CurrentUser.item.msgcount = data.messageCount;
          }
        );
    } else {
      this.patientService.countrange(this.CurrentUser.item.userAccountId, 'N', 'N')
        .subscribe(
          data => {
            this.CurrentUser.item.msgcount = data.messageCount;
          })
    }
  }
}